var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    isOpenDialog: false,
    fileResults: []
};
var globalSearchSlice = createSlice({
    name: 'globalSearch',
    initialState: initialState,
    reducers: {
        setFilePath: function (state, action) {
            state.filePath = action.payload;
        },
        setIsOpenDialog: function (state, action) {
            state.isOpenDialog = action.payload;
        },
        setFileResults: function (state, action) {
            if (typeof action.payload === 'function') {
                state.fileResults = action.payload(state.fileResults);
            }
            else {
                state.fileResults = action.payload;
            }
        }
    }
});
export var setFilePath = (_a = globalSearchSlice.actions, _a.setFilePath), setIsOpenDialog = _a.setIsOpenDialog, setFileResults = _a.setFileResults;
export default globalSearchSlice.reducer;
